module.exports = __webpack_public_path__ + "img/logo_uajy_single.61d963e0.png";